import axios from "axios";

const IS_DEV = process.env.NODE_ENV === "development";
const QINIU_TOKEN_BASE_URL = IS_DEV
  ? "https://sf-api-test.v2gogo.com"
  : "https://sf-api.v2gogo.com";
const QINIU_UPLOAD_URL = "https://up-z2.qiniup.com";

function pad2(value) {
  return String(value).padStart(2, "0");
}

function formatDatePath(date = new Date()) {
  return `${date.getFullYear()}/${pad2(date.getMonth() + 1)}/${pad2(date.getDate())}`;
}

function normalizeFileType(fileType) {
  const normalized = String(fileType || "").trim().replace(/^\./, "");
  return normalized || "jpg";
}

function extractFileType(file, fallbackFileType) {
  if (fallbackFileType) {
    return normalizeFileType(fallbackFileType);
  }
  const fileName = file && file.name || "";
  const parts = fileName.split(".");
  if (parts.length > 1) {
    return normalizeFileType(parts.pop());
  }
  return "jpg";
}

async function resolveUploadFile(file) {
  const isBrowserFile = typeof File !== "undefined" && file instanceof File;
  const isBrowserBlob = typeof Blob !== "undefined" && file instanceof Blob;
  if (isBrowserFile || isBrowserBlob) {
    return file;
  }
  if (typeof file === "string" && /^https?:\/\//.test(file)) {
    const response = await fetch(file);
    if (!response.ok) {
      throw new Error("文件地址无效，无法上传");
    }
    return response.blob();
  }
  throw new Error("请传入 File、Blob 或 http(s) 文件地址");
}

export async function getQiNiuToken(fileType) {
  const normalizedType = normalizeFileType(fileType);
  const nowDate = formatDatePath(new Date());
  const key = `mediaResources/${nowDate}/${Date.now()}.${normalizedType}`;
  const response = await axios.request({
    baseURL: QINIU_TOKEN_BASE_URL,
    url: "/file/upload/getVideoToken",
    method: "POST",
    data: {
      path: key
    }
  });
  const token = response && response.data && response.data.data;
  if (!token) {
    throw new Error(response?.data?.message || "获取上传 token 失败");
  }
  return {
    token,
    key
  };
}

export async function uploadFile(file, fileType) {
  const uploadFileValue = await resolveUploadFile(file);
  const normalizedType = extractFileType(file, fileType);
  const { token, key } = await getQiNiuToken(normalizedType);
  const formData = new FormData();
  formData.append("key", key);
  formData.append("token", token);
  formData.append("file", uploadFileValue);
  const response = await axios.request({
    url: QINIU_UPLOAD_URL,
    method: "POST",
    data: formData
  });
  if (response?.status !== 200) {
    throw new Error(response?.data?.error || "上传失败");
  }
  const uploadResult = response?.data || {};
  return uploadResult.url || uploadResult?.data?.url || uploadResult.key || key;
}

export default {
  uploadFile,
  getQiNiuToken
};
